import React, { useContext, useEffect, useState } from 'react'
import './FilterPanel.css'
import { withStyles } from '@material-ui/core/styles'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import RadioBox, { GreenRadio } from '../../atoms/RadioBox'
// import ProductContext from '../../../../product/context/product/productContext'
// import CustomCommonContext from '../../../../custom/context/common/commonContext'
// import ProductCommonContext from '../../../../product/context/common/commonContext'
import { useFormik } from 'formik'
import { Button, useMediaQuery } from '@material-ui/core'
import { Slider } from '@material-ui/core'
import { mapData } from '../../../common/components'
import CheckBox from '../../atoms/CheckBox'
import CommonContext from '../../../../Product/context/product/productContext'
import RangeFilter from '../RangeFilter'

const Accordion = withStyles({
    root: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion)

const AccordionSummary = withStyles({
    root: {
        backgroundColor: '#fff',
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 50,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(MuiAccordionSummary)

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiAccordionDetails)

const FilterPanel = (props) => {
    const formik = props.formik
    const filterValues = props.filterValues
    const [expanded, setExpanded] = useState(() => {
        return props.filterValues
            .map((f, i) => (f.defaultOpen ? `panel${i}` : null))
            .filter(Boolean)
    })
    const [toggleFilterDrawer, setToggleFilterDrawer] = useState(false)
    const isBuyBestProject = global.storeConfigration?.bodyClass2?.value === 'buyBestProject'
    useEffect(() => {
        if (props.isBitCatOpen === false && window.innerWidth < 780) {
            setExpanded('')
        }
    }, [props.isBitCatOpen])
    // const handleChange = (panel) => (event, newExpanded) => {
    //     if (panel === expanded && !newExpanded) {
    //         setExpanded(newExpanded ? panel : false)
    //     } else {
    //         setExpanded(newExpanded ? panel : false)
    //     }
    // }
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded((prevExpanded) =>
            isExpanded ? [...prevExpanded, panel] : prevExpanded.filter((p) => p !== panel),
        )
    }
    const handleFilter = (min, max) => {
        props.formik.setFieldValue('toprice', 7)
        props.formik.setFieldValue('mprice_filter', [min, max])
    }

    const isMobile = useMediaQuery('(max-width:600px)')
    const isBidDepotProject = document.body.classList[1] == 'BidAuctionDepot'
    const isWizardTheme = document.body.classList[1] == 'wizardTheme'
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'

    return (
        <div className="filterPanel">
            {global.storeDetails?.theme !== 18 ||
                (!isBidDepotProject && (
                    <div className="d-flex justify-content-between align-items-center filterTitleCnt">
                        <h4 className="fpTitle">Filters</h4>
                    </div>
                ))}
            <div>
                {props.clearSearch && (
                    <Button onClick={() => props.clearSearch()} className="filterClear">
                        <span className="material-icons">cancel</span>
                        Clear all
                    </Button>
                )}
            </div>

            {isVarifiedGfTheme && (
                <div className="d-flex align-items-center justify-content-between">
                    <Button
                        className="filterAccordionBtn"
                        variant="outlined"
                        onClick={() => setToggleFilterDrawer(!toggleFilterDrawer)}
                    >
                        <span className="material-icons">filter_list</span>
                        Filters
                        <span className="material-icons">
                            {toggleFilterDrawer ? 'expand_less' : 'expand_more'}
                        </span>
                    </Button>
                    {isMobile ? (
                        <div className="d-flex justify-content-between align-item-center w-100 mb-3">
                            <Button
                                className="filterClearAllBtn"
                                onClick={() => {
                                    props.clearAll()
                                }}
                            >
                                <span
                                    className="material-icons-outlined mr-1"
                                    style={{ fontSize: '18px' }}
                                >
                                    cancel
                                </span>
                                Clear All
                            </Button>
                            <Button className="filterCloseBtn" onClick={props.closeToggle}>
                                <span
                                    className="material-icons-outlined mr-1"
                                    style={{ fontSize: '18px' }}
                                >
                                    clear
                                </span>
                            </Button>
                        </div>
                    ) : (
                        <Button
                            className="filterClearAllBtn"
                            onClick={() => {
                                props.clearAll()
                            }}
                        >
                            <span
                                className="material-icons-outlined mr-1"
                                style={{ fontSize: '18px' }}
                            >
                                cancel
                            </span>
                            Clear All
                        </Button>
                    )}
                </div>
            )}

            {props.custom ? (
                <div className="row">{Object.values(mapData(props.filterValues))}</div>
            ) : (
                <div className={toggleFilterDrawer ? 'filterAcc collaspedFiltePanel' : 'filterAcc'}>
                    {filterValues?.map((data, index) => (
                        <>
                            {!data.hide ? (
                                props.allOpen ? (
                                    <Accordion
                                        square
                                        key={index}
                                        defaultExpanded={true}
                                        // expanded={expanded === `panel${index}`}
                                        onChange={handleChange(`panel${index}`)}
                                        className={data.class}
                                    >
                                        <AccordionSummary
                                            expandIcon={isWizardTheme ? null : <ExpandMoreIcon />}
                                            aria-controls="panel1d-content"
                                            id={`panel${index}d-header`}
                                        >
                                            <h6 className="accTitle">{data.title}</h6>
                                        </AccordionSummary>
                                        <AccordionDetails
                                            className={
                                                data.title == 'Location'
                                                    ? props.locationInfo && 'locationAccord'
                                                    : null
                                            }
                                        >
                                            {data.title == 'Location'
                                                ? props.locationInfo && (
                                                      <div className="SelectedlocationInfo">
                                                          <svg
                                                              width="20"
                                                              height="20"
                                                              viewBox="0 0 20 20"
                                                              fill="none"
                                                              xmlns="http://www.w3.org/2000/svg"
                                                          >
                                                              <path
                                                                  d="M2.5 17.5003V5.83366H7.5V4.16699L10 1.66699L12.5 4.16699V9.16699H17.5V17.5003H2.5ZM4.16667 15.8337H5.83333V14.167H4.16667V15.8337ZM4.16667 12.5003H5.83333V10.8337H4.16667V12.5003ZM4.16667 9.16699H5.83333V7.50033H4.16667V9.16699ZM9.16667 15.8337H10.8333V14.167H9.16667V15.8337ZM9.16667 12.5003H10.8333V10.8337H9.16667V12.5003ZM9.16667 9.16699H10.8333V7.50033H9.16667V9.16699ZM9.16667 5.83366H10.8333V4.16699H9.16667V5.83366ZM14.1667 15.8337H15.8333V14.167H14.1667V15.8337ZM14.1667 12.5003H15.8333V10.8337H14.1667V12.5003Z"
                                                                  fill="#E8EAED"
                                                              />
                                                          </svg>

                                                          <div>
                                                              <h4>Richardson</h4>
                                                              <p>1221</p>
                                                          </div>
                                                      </div>
                                                  )
                                                : null}
                                            <div className="filterCheck d-flex align-items-center flex-wrap">
                                                {mapData([data])}
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                ) : (
                                    <Accordion
                                        square
                                        key={index}
                                        expanded={expanded.includes(`panel${index}`)}
                                        // expanded={expanded === `panel${index}`}
                                        onChange={handleChange(`panel${index}`)}
                                        className={data.class}
                                    >
                                        <AccordionSummary
                                            expandIcon={isWizardTheme ? null : <ExpandMoreIcon />}
                                            aria-controls="panel1d-content"
                                            id={`panel${index}d-header`}
                                        >
                                            <h6 className="accTitle">{data.title}</h6>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <div className="filterCheck d-flex align-items-center flex-wrap">
                                                {data.priceRange && (
                                                    <>
                                                        <RangeFilter onFilter={handleFilter} />
                                                    </>
                                                )}
                                                {mapData([data])}
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                )
                            ) : null}
                        </>
                    ))}
                    {props.filterData ? (
                        <Accordion
                            square
                            key={'pfil'}
                            expanded={expanded.includes('panelpfil')}
                            onChange={handleChange(`panel${'pfil'}`)}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1d-content"
                                id={`panel${'pfil'}d-header`}
                            >
                                <h6 className="accTitle">{props.label}</h6>
                            </AccordionSummary>
                            <AccordionDetails>{mapData(props.filterData)}</AccordionDetails>
                        </Accordion>
                    ) : (
                        ''
                    )}
                </div>
            )}
        </div>
    )
}
export default FilterPanel
